// Bank Name
export const hosBankListApi = 'configuration/bank/list'
export const hosBankStoreApi = 'configuration/bank/store'
export const hosBankUpdateApi = 'configuration/bank/update'
export const hosBankDeleteApi = 'configuration/bank/toggle-status'

// Branch
export const bankBranchListApi = 'configuration/branch/list'
export const bankBranchStoreApi = 'configuration/branch/store'
export const bankBranchUpdateApi = 'configuration/branch/update'
export const bankBranchToggleStatusApi = 'configuration/branch/toggle-status'

// Hospital
export const hospitaListApi = 'configuration/hospital/list'
export const hospitaLInfoApi = 'configuration/hospital/info'
export const hospitaThirtyPercentListApi = 'configuration/hospital/thirty-percent-list'
export const hospitaListPdfApi = 'configuration/hospital/pdf-list'
export const hospitalStoreApi = 'configuration/hospital/store'
export const hospitalUpdateApi = 'configuration/hospital/update'
export const hospitalToggleStatusApi = 'configuration/hospital/toggle-status'
export const assignUserHospitalApi = 'configuration/hospital/user-hospital'
export const hospitaCopyDataApi = 'configuration/hospital/copy-data'

// Hospital bank account
export const hospitalBankAccountListApi = 'configuration/hospital-bank-account/list'
export const hospitalBankAccountStoreApi = 'configuration/hospital-bank-account/store'
export const hospitalBankAccountUpdateApi = 'configuration/hospital-bank-account/update'
export const hospitalBankAccountToggleStatusApi = 'configuration/hospital-bank-account/toggle-status'
export const hospitalBankAccountCheckIsPrimary = 'configuration/hospital-bank-account/is-primary'

// Hospital fdr account
export const hospitalFdrAccountListApi = 'configuration/hospital-fdr-account/list'
export const hospitalFdrAccountStoreApi = 'configuration/hospital-fdr-account/store'
export const hospitalFdrAccountUpdateApi = 'configuration/hospital-fdr-account/update'
export const hospitalFdrAccountToggleStatusApi = 'configuration/hospital-fdr-account/toggle-status'
export const BankListApi = '/configuration/hospital-bank-account/get-bank-list'

// Services
export const servicesListApi = 'configuration/hospital-services/list'
export const servicesStoreApi = 'configuration/hospital-services/store'
export const servicesUpdateApi = 'configuration/hospital-services/update'
export const servicesToggleStatusApi = 'configuration/hospital-services/toggle-status'

// Donation mode
export const donationModeListApi = 'configuration/donation-mode/list'
export const donationModeStoreApi = 'configuration/donation-mode/store'
export const donationModeUpdateApi = 'configuration/donation-mode/update'
export const donationModeToggleStatusApi = 'configuration/donation-mode/toggle-status'
// Designation Info
export const designationListApi = 'configuration/hospital/list'
export const designationStoreApi = 'configuration/designation-info/store'
export const designationUpdateApi = 'configuration/designation-info/update'
export const designationToggleStatusApi = 'configuration/designation-info/toggle-status'

// Hospital Department
export const departmentListApi = 'configuration/hospital-department/list'
export const departmentStoreApi = 'configuration/hospital-department/store'
export const departmentUpdateApi = 'configuration/hospital-department/update'
export const departmentToggleStatusApi = 'configuration/hospital-department/toggle-status'

// Disease Info
export const diseaseInfoListApi = 'configuration/disease-info/list'
export const diseaseInfoStoreApi = 'configuration/disease-info/store'
export const diseaseInfoUpdateApi = 'configuration/disease-info/update'
export const diseaseInfoToggleStatusApi = 'configuration/disease-info/toggle-status'
// disability type
export const disabilityTypeListApi = 'configuration/disability-type/list'
export const disabilityTypeStoreApi = 'configuration/disability-type/store'
export const disabilityTypeUpdateApi = 'configuration/disability-type/update'
export const disabilityTypeToggleStatusApi = 'configuration/disability-type/toggle-status'

// Store Item
export const storeItemListApi = 'configuration/store-item/list'
export const storeItemStoreApi = 'configuration/store-item/store'
export const storeItemUpdateApi = 'configuration/store-item/update'
export const storeItemToggleStatusApi = 'configuration/store-item/toggle-status'

// campaign designation
export const campaignDesignationListApi = 'configuration/campaign-designation/list'
export const campaignDesignationStoreApi = 'configuration/campaign-designation/store'
export const campaignDesignationUpdateApi = 'configuration/campaign-designation/update'
export const campaignDesignationToggleStatusApi = 'configuration/campaign-designation/toggle-status'

// assign user
export const assignUserListApi = 'configuration/assign-user/list'
export const assignUserStoreApi = 'configuration/assign-user/store'
export const assignUserShowApi = 'configuration/assign-user/show'
export const assignUserUpdateApi = 'configuration/assign-user/update'
export const assignUserToggleStatusApi = 'configuration/assign-user/toggle-status'
export const userDropDataApi = 'configuration/assign-user/users-data'
export const userListApi = 'user/users-by-designation-id'
export const getUserListApi = 'user/get-all-users'
export const getAssignedUserDetailApi = 'configuration/user-detail'
export const deleteAssignedUserHospital = 'configuration/assign-user/delete'

// assign department
export const assignDeptListApi = 'configuration/assign-department/list'
export const assignDeptShowApi = 'configuration/assign-department/show'
export const assignDeptStoreApi = 'configuration/assign-department/store'
export const assignDeptUpdateApi = 'configuration/assign-department/update'
export const assignDeptToggleStatusApi = 'configuration/assign-department/toggle-status'

// Hospital Ward
export const wardListApi = 'configuration/ward/list'
export const wardStoreApi = 'configuration/ward/store'
export const wardUpdateApi = 'configuration/ward/update'
export const wardToggleStatusApi = 'configuration/ward/toggle-status'
export const deleteWardApi = 'configuration/ward/delete'
export const getWardsApi = 'configuration/ward/get-wards'

// Hospital Bed
export const hospitalBedListApi = 'configuration/hospital-bed/list'
export const hospitalBedShowApi = 'configuration/hospital-bed/show'
export const hospitalBedStoreApi = 'configuration/hospital-bed/store'
export const hospitalBedUpdateApi = 'configuration/hospital-bed/update'
export const hospitalBedToggleStatusApi = 'configuration/hospital-bed/toggle-status'

// Store Item
const itemCategoryBase = 'configuration/item-category'
export const itemCategoryListApi = itemCategoryBase + '/list'
export const itemCategoryStoreApi = itemCategoryBase + '/store'
export const itemCategoryUpdateApi = itemCategoryBase + '/update'
export const itemCategoryToggleStatusApi = itemCategoryBase + '/toggle-status'

// Samiti Form
export const samitiFormListApi = 'configuration/samiti-form/list'
export const samitiFormShowApi = 'configuration/samiti-form/show'
export const samitiFormStoreApi = 'configuration/samiti-form/store'
export const samitiFormUpdateApi = 'configuration/samiti-form/update'
export const samitiFormToggleStatusApi = 'configuration/samiti-form/toggle-status'

// Report Heading
export const reportHeadingList = 'configuration/report-heading/list'
export const reportHeadingStore = 'configuration/report-heading/store'
export const reportHeadingUpdate = 'configuration/report-heading/update'
export const reportHeadingDetail = 'configuration/report-heading/detail'
export const reportToggleStatus = 'configuration/report-heading/toggle-status'

// Therapy Service
export const ServiceList = 'configuration/therapy-service/list'
export const ServiceListAll = 'configuration/therapy-service/all'
export const ServiceStore = 'configuration/therapy-service/store'
export const ServiceUpdate = 'configuration/therapy-service/update'
export const ServiceDetail = 'configuration/therapy-service/detail'
export const ServiceToggleStatus = 'configuration/therapy-service/toggle-status'

// Dashboard
export const totalPatientsApi = 'dashboard/total-patients'
export const totalServiceDeliveryApi = 'dashboard/total-service-delivery'
export const totalDonationApi = 'dashboard/total-donation'
export const totalCaseHistoryApi = 'dashboard/total-case-history'
export const totalFollowUpsApi = 'dashboard/total-followup'
export const cashPaymentsApi = 'dashboard/total-cash-payment'
export const totalTherapyPatientsApi = 'dashboard/total-therapy-patients'
export const totalTherapyApplicationApi = 'dashboard/total-therapy-applications'
export const totalTherapyPendingApplicationApi = 'dashboard/total-therapy-pending-applications'
export const totalTherapyCentersApi = 'dashboard/total-therapy-centers'
export const totalTherapyCompletedApi = 'dashboard/total-therapy-completed'
export const yearlyTotalTherapyCompletedApi = 'dashboard/yearly-total-therapy-completed'
export const trimonthlyPatientRegReportApi = 'dashboard/tri-monthly-patient-registration'

// Dashboard
export const totalPatients30pcApi = 'thirty-pc-dashboard/total-patients'
export const totalServiceDelivery30pcApi = 'thirty-pc-dashboard/total-service-delivery'
export const totalDonation30pcApi = 'thirty-pc-dashboard/total-donation'

// Patient Welfare
 export const patientWelfareListApi = 'configuration/patient-welfare/list'
// export const hospitaListPdfApi = 'configuration/hospital/pdf-list'
export const patientWelfareStoreApi = 'configuration/patient-welfare/store'
export const patientWelfareUpdateApi = 'configuration/patient-welfare/update'
export const patientWelfareToggleStatusApi = 'configuration/patient-welfare/toggle-status'
// export const assignUserHospitalApi = 'configuration/hospital/user-hospital'

export const getPrescription = '/consultancy-therapy-center/therapy-management/prescription-list'

// Dc pool
export const dcpoolListApi = 'configuration/dc-pool/list'
export const dcpoolStoreApi = 'configuration/dc-pool/store'
export const dcpoolUpdateApi = 'configuration/dc-pool/update'
export const dcpoolToggleStatusApi = 'configuration/dc-pool/toggle-status'

// Van Info Info
export const vanInfoListApi = 'configuration/van-info/list'
export const vanInfoStoreApi = 'configuration/van-info/store'
export const vanInfoUpdateApi = 'configuration/van-info/update'
export const vanInfoToggleStatusApi = 'configuration/van-info/toggle-status'
export const vanInfoDestroyApi = 'configuration/van-info/destroy'

// Sub Center api
export const subCenterList = 'configuration/sub-center/list'
export const subCenterStore = 'configuration/sub-center/store'
export const subCenterUpdate = 'configuration/sub-center/update'
export const subCenterToggleStatus = 'configuration/sub-center/toggle-status'

// Van Assign api
export const vanAssignList = 'configuration/van-assign/list'
export const vanAssignStore = 'configuration/van-assign/store'
export const vanAssignUpdate = 'configuration/van-assign/update'
export const vanAssignToggleStatus = 'configuration/van-assign/toggle-status'

// Driver Info
export const driverinfoListApi = 'configuration/driver-info/list'
export const driverinfoStoreApi = 'configuration/driver-info/store'
export const driverinfoUpdateApi = 'configuration/driver-info/update'
export const driverinfoToggleStatusApi = 'configuration/driver-info/toggle-status'

// Driver Info
export const driverAssignListApi = 'configuration/driver-assign/list'
export const driverAssignStoreApi = 'configuration/driver-assign/store'
export const driverAssignUpdateApi = 'configuration/driver-assign/update'
export const driverAssignToggleStatusApi = 'configuration/driver-assign/toggle-status'
